"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var TeachingBubbleContent_base_1 = require("./TeachingBubbleContent.base");
var TeachingBubble_styles_1 = require("./TeachingBubble.styles");
exports.TeachingBubbleContent = Utilities_1.styled(TeachingBubbleContent_base_1.TeachingBubbleContentBase, TeachingBubble_styles_1.getStyles, undefined, { scope: 'TeachingBubbleContent' });
//# sourceMappingURL=TeachingBubbleContent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/TeachingBubble/TeachingBubbleContent.js
// module id = 1216
// module chunks = 0